import React from 'react';
import TimeSlotItem from './TimeSlotItem';
import { TimeSlot } from './steps/SelectYourAvailability';

interface TimeSlotsListProps {
  timeSlots: TimeSlot[];
  selectedTimes?: TimeSlot[];
  isDisabled?: boolean;
  onTimeSelect?: (time: TimeSlot) => void;
  day?: string;
}

const TimeSlotsList: React.FC<TimeSlotsListProps> = ({
  timeSlots,
  selectedTimes = [],
  isDisabled = false,
  onTimeSelect = () => {},
  day,
}) => (
  <div className="grid grid-cols-2 gap-2">
    {timeSlots.map((time) => {
      const isSelected = selectedTimes.some((t) => t.label === time.label);

      return (
        <TimeSlotItem
          key={time.label}
          time={time}
          isSelected={isSelected}
          isDisabled={isDisabled}
          onClick={() => {
            if (day) {
              onTimeSelect(time);
            }
          }}
        />
      );
    })}
  </div>
);

export default TimeSlotsList;
